"use strict";
exports.__esModule = true;
exports.ROUNDED = exports.SIZES = exports.CONTAINER_SIZES = exports.SELECTED_COLORS = exports.COLOR_VARIANTS = exports.OUTLINED_COLORS = exports.COLORS = exports.BG_COLORS = void 0;
exports.BG_COLORS = {
    primary: 'bg-primary border border-primary',
    danger: 'bg-danger border border-danger',
    warning: 'bg-warning border border-warning',
    secondary: 'bg-secondary border border-secondary',
    control: 'bg-control border border-control',
    tertiary: 'bg-tertiary border border-tertiary',
    success: 'bg-success border border-success',
    info: 'bg-info border border-info',
    inherit: 'bg-transparent border border-inherit',
    slate: 'bg-slate-500 border border-slate-500',
    zinc: 'bg-zinc-500 border border-zinc-500',
    neutral: 'bg-neutral-500 border border-neutral-500',
    stone: 'bg-stone-500 border border-stone-500',
    red: 'bg-red-500 border border-red-500',
    orange: 'bg-orange-500 border border-orange-500',
    amber: 'bg-amber-500 border border-amber-500',
    yellow: 'bg-yellow-500 border border-yellow-500',
    lime: 'bg-lime-500 border border-lime-500',
    green: 'bg-green-500 border border-green-500',
    emerald: 'bg-emerald-500 border border-emerald-500',
    teal: 'bg-teal-500 border border-teal-500',
    cyan: 'bg-cyan-500 border border-cyan-500',
    sky: 'bg-sky-500 border border-sky-500',
    blue: 'bg-blue-500 border border-blue-500',
    indigo: 'bg-indigo-500 border border-indigo-500',
    violet: 'bg-violet-500 border border-violet-500',
    purple: 'bg-purple-500 border border-purple-500',
    fuchsia: 'bg-fuchsia-500 border border-fuchsia-500',
    pink: 'bg-pink-500 border border-pink-500',
    rose: 'bg-rose-500 border border-rose-500'
};
exports.COLORS = {
    primary: 'bg-white text-primary hover:bg-primary-100 hover:text-primary-dark',
    danger: 'bg-white text-danger hover:bg-danger-100 hover:!text-danger-dark',
    warning: 'bg-white text-warning hover:bg-warning-100 hover:!text-warning-dark',
    secondary: 'bg-white text-secondary hover:bg-secondary-100 hover:!text-secondary-dark',
    control: 'bg-white text-control hover:bg-control-100 hover:!text-control-dark',
    tertiary: 'bg-white text-tertiary hover:bg-tertiary-100 hover:!text-tertiary-dark',
    success: 'bg-white text-success hover:bg-success-100 hover:!text-success-dark',
    info: 'bg-white text-info hover:bg-info-100 hover:!text-info-dark',
    inherit: 'bg-transparent !border-inherit-dark !hover:border-inherit-dark',
    slate: 'bg-white text-slate-500 hover:bg-slate-100 hover:!text-slate-700',
    zinc: 'bg-white text-zinc-500 hover:bg-zinc-100 hover:!text-zinc-700',
    neutral: 'bg-white text-neutral-500 hover:bg-neutral-100 hover:!text-neutral-700',
    stone: 'bg-white text-stone-500 hover:bg-stone-100 hover:!text-stone-700',
    red: 'bg-white text-red-500 hover:bg-red-100 hover:!text-red-700',
    orange: 'bg-white text-orange-500 hover:bg-orange-100 hover:!text-orange-700',
    amber: 'bg-white text-amber-500 hover:bg-amber-100 hover:!text-amber-700',
    yellow: 'bg-white text-yellow-500 hover:bg-yellow-100 hover:!text-yellow-700',
    lime: 'bg-white text-lime-500 hover:bg-lime-100 hover:!text-lime-700',
    green: 'bg-white text-green-500 hover:bg-green-100 hover:!text-green-700',
    emerald: 'bg-white text-emerald-500 hover:bg-emerald-100 hover:!text-emerald-700',
    teal: 'bg-white text-teal-500 hover:bg-teal-100 hover:!text-teal-700',
    cyan: 'bg-white text-cyan-500 hover:bg-cyan-100 hover:!text-cyan-700',
    sky: 'bg-white text-sky-500 hover:bg-sky-100 hover:!text-sky-700',
    blue: 'bg-white text-blue-500 hover:bg-blue-100 hover:!text-blue-700',
    indigo: 'bg-white text-indigo-500 hover:bg-indigo-100 hover:!text-indigo-700',
    violet: 'bg-white text-violet-500 hover:bg-violet-100 hover:!text-violet-700',
    purple: 'bg-white text-purple-500 hover:bg-purple-100 hover:!text-purple-700',
    fuchsia: 'bg-white text-fuchsia-500 hover:bg-fuchsia-100 hover:!text-fuchsia-700',
    pink: 'bg-white text-pink-500 hover:bg-pink-100 hover:!text-pink-700',
    rose: 'bg-white text-rose-500 hover:bg-rose-100 hover:!text-rose-700'
};
exports.OUTLINED_COLORS = {
    primary: 'bg-white text-primary hover:bg-primary-100 hover:text-primary-dark',
    danger: 'bg-white text-danger hover:bg-danger-100 hover:text-danger-dark',
    warning: 'bg-white text-warning hover:bg-warning-100 hover:text-warning-dark',
    secondary: 'bg-white text-secondary hover:bg-secondary-100 hover:text-secondary-dark',
    tertiary: 'bg-white text-tertiary hover:bg-tertiary-100 hover:text-tertiary-dark',
    success: 'bg-white text-success hover:bg-success-100 hover:text-success-dark',
    info: 'bg-white text-info hover:bg-info-100 hover:text-info-dark',
    control: 'bg-white text-control hover:bg-control-100',
    inherit: 'bg-transparent hover:bg-transparent',
    slate: 'bg-white text-slate-500 hover:bg-slate-100 hover:text-slate-700',
    zinc: 'bg-white text-zinc-500 hover:bg-zinc-100 hover:text-zinc-700',
    neutral: 'bg-white text-neutral-500 hover:bg-neutral-100 hover:text-neutral-700',
    stone: 'bg-white text-stone-500 hover:bg-stone-100 hover:text-stone-700',
    red: 'bg-white text-red-500 hover:bg-red-100 hover:text-red-700',
    orange: 'bg-white text-orange-500 hover:bg-orange-100 hover:text-orange-700',
    amber: 'bg-white text-amber-500 hover:bg-amber-100 hover:text-amber-700',
    yellow: 'bg-white text-yellow-500 hover:bg-yellow-100 hover:text-yellow-700',
    lime: 'bg-white text-lime-500 hover:bg-lime-100 hover:text-lime-700',
    green: 'bg-white text-green-500 hover:bg-green-100 hover:text-green-700',
    emerald: 'bg-white text-emerald-500 hover:bg-emerald-100 hover:text-emerald-700',
    teal: 'bg-white text-teal-500 hover:bg-teal-100 hover:text-teal-700',
    cyan: 'bg-white text-cyan-500 hover:bg-cyan-100 hover:text-cyan-700',
    sky: 'bg-white text-sky-500 hover:bg-sky-100 hover:text-sky-700',
    blue: 'bg-white text-blue-500 hover:bg-blue-100 hover:text-blue-700',
    indigo: 'bg-white text-indigo-500 hover:bg-indigo-100 hover:text-indigo-700',
    violet: 'bg-white text-violet-500 hover:bg-violet-100 hover:text-violet-700',
    purple: 'bg-white text-purple-500 hover:bg-purple-100 hover:text-purple-700',
    fuchsia: 'bg-white text-fuchsia-500 hover:bg-fuchsia-100 hover:text-fuchsia-700',
    pink: 'bg-white text-pink-500 hover:bg-pink-100 hover:text-pink-700',
    rose: 'bg-white text-rose-500 hover:bg-rose-100 hover:text-rose-700'
};
var COLOR_VARIANTS = function (_a) {
    var color = _a.color, variant = _a.variant;
    if (variant === "filled") {
        return exports.COLORS[color];
    }
    return exports.OUTLINED_COLORS[color];
};
exports.COLOR_VARIANTS = COLOR_VARIANTS;
exports.SELECTED_COLORS = {
    primary: '!bg-primary !text-primary-100 hover:!bg-primary-dark',
    danger: '!bg-danger !text-danger-100 hover:!bg-danger-dark',
    warning: '!bg-warning !text-warning-100 hover:!bg-warning-dark',
    secondary: '!bg-secondary !text-secondary-100 hover:!bg-secondary-dark',
    control: '!bg-control !text-control-100 hover:!bg-control-dark',
    tertiary: '!bg-tertiary !text-tertiary-100 hover:!bg-tertiary-dark',
    success: '!bg-success !text-success-100 hover:!bg-success-dark',
    info: '!bg-info !text-info-100 hover:!bg-info-dark',
    inherit: 'bg-inherit-dark !text-inherit-100',
    slate: '!bg-slate-500 !text-slate-100 hover:!bg-slate-700',
    zinc: '!bg-zinc-500 !text-zinc-100 hover:!bg-zinc-700',
    neutral: '!bg-neutral-500 !text-neutral-100 hover:!bg-neutral-700',
    stone: '!bg-stone-500 !text-stone-100 hover:!bg-stone-700',
    red: '!bg-red-500 !text-red-100 hover:!bg-red-700',
    orange: '!bg-orange-500 !text-orange-100 hover:!bg-orange-700',
    amber: '!bg-amber-500 !text-amber-100 hover:!bg-amber-700',
    yellow: '!bg-yellow-500 !text-yellow-100 hover:!bg-yellow-700',
    lime: '!bg-lime-500 !text-lime-100 hover:!bg-lime-700',
    green: '!bg-green-500 !text-green-100 hover:!bg-green-700',
    emerald: '!bg-emerald-500 !text-emerald-100 hover:!bg-emerald-700',
    teal: '!bg-teal-500 !text-teal-100 hover:!bg-teal-700',
    cyan: '!bg-cyan-500 !text-cyan-100 hover:!bg-cyan-700',
    sky: '!bg-sky-500 !text-sky-100 hover:!bg-sky-700',
    blue: '!bg-blue-500 !text-blue-100 hover:!bg-blue-700',
    indigo: '!bg-indigo-500 !text-indigo-100 hover:!bg-indigo-700',
    violet: '!bg-violet-500 !text-violet-100 hover:!bg-violet-700',
    purple: '!bg-purple-500 !text-purple-100 hover:!bg-purple-700',
    fuchsia: '!bg-fuchsia-500 !text-fuchsia-100 hover:!bg-fuchsia-700',
    pink: '!bg-pink-500 !text-pink-100 hover:!bg-pink-700',
    rose: '!bg-rose-500 !text-rose-100 hover:!bg-rose-700'
};
exports.CONTAINER_SIZES = {
    huge: 'h-14 md:h-16',
    large: 'h-12 md:h-14',
    medium: 'h-10 md:h-12',
    small: 'h-8 md:h-10',
    tiny: 'h-6 md:h-8'
};
exports.SIZES = {
    huge: 'h-[54px] md:h-[62px]',
    large: 'h-[52px] md:h-[54px]',
    medium: 'h-[38px] md:h-[46px]',
    small: 'h-[30px] md:h-[38px]',
    tiny: 'h-[22px] md:h-[30px]'
};
exports.ROUNDED = {
    full: 'rounded-full',
    huge: 'rounded-3xl',
    large: 'rounded-2xl',
    medium: 'rounded-lg',
    small: 'rounded',
    tiny: 'rounded-sm',
    none: 'rounded-none'
};
//# sourceMappingURL=toggle-button-group.style.js.map